import { FocusMonitor } from '@angular/cdk/a11y';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { DecimalPipe } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { NumberCommaToDotFormatPipe } from '@app/shared/pipes/number-comma-to-dot-format.pipe';
import { Subject } from 'rxjs';

export class CustomRange {
  constructor(public fromAmount: string, public toAmount: string) {}
}

@Component({
  selector: 'app-custom-amount-range-input',
  templateUrl: './custom-amount-range-input.component.html',
  styleUrls: ['./custom-amount-range-input.component.scss'],
})
export class CustomAmountRangeInputComponent
  implements MatFormFieldControl<CustomRange>
{
  ngControl: NgControl;
  stateChanges = new Subject<void>();
  errorState = false;
  placeholder: string;
  empty: boolean;
  shouldLabelFloat: boolean;
  autofilled?: boolean;

  public _placeholder: string;
  public focused: boolean;
  public _elementRef: ElementRef;
  public _disabled = false;
  public _required = false;
  public _value: CustomRange = new CustomRange('', '');
  public _valueFrom: number | null;
  public _valueTo: number | null;

  @Input()
  get required() {
    return this._required;
  }
  set required(req) {
    this._required = coerceBooleanProperty(req);

    this.stateChanges.next();
  }

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(dis) {
    this._disabled = coerceBooleanProperty(dis);
    this.stateChanges.next();
  }

  @Input()
  get value(): CustomRange | null {
    return this._value;
  }
  set value(valueFrom: CustomRange | null) {
    this._value = valueFrom;
    this.stateChanges.next();
  }

  @Input()
  get valueFrom(): number | null {
    return this._valueFrom;
  }
  set valueFrom(valueFrom: number | null) {
    this._valueFrom = this.formatValue(valueFrom);
    this.stateChanges.next();
  }

  @Input()
  get valueTo(): number | null {
    return this._valueTo;
  }
  set valueTo(valueTo: number | null) {
    this._valueTo = this.formatValue(valueTo);
    this.stateChanges.next();
  }

  @Input() typeFrom: string | null;
  @Input() typeTo: string | null;

  @Input('aria-describedby') userAriaDescribedBy: string = '';

  constructor(
    public elRef: ElementRef,
    public fm: FocusMonitor,
    private decimalPipe: DecimalPipe,
    private numberFormatPipe: NumberCommaToDotFormatPipe
  ) {
    this._elementRef = elRef;
  }

  setDescribedByIds(ids: string[]): void {}

  onContainerClick(event: MouseEvent): void {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this._elementRef.nativeElement.querySelector('input').focus();
    }
  }

  static nextId = 0;
  @HostBinding() id = `custom-list-${CustomAmountRangeInputComponent.nextId++}`;

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  @Output() onValueChange: EventEmitter<{ type: string; selectedValue: any }> =
    new EventEmitter<{ type: string; selectedValue: any }>();

  valueChange(_type: string, _selectedAmount: any) {
    this.onValueChange.emit({ type: _type, selectedValue: _selectedAmount });
  }

  formatValue(value: number): number {
    if (value) {
      const newValue = this.decimalPipe.transform(
        value.toString().replace(',', '.'),
        '1.2-2'
      );
      return this.numberFormatPipe.transformfromString(newValue);
    }
    return null;
  }
}
